import { render, staticRenderFns } from "./Passport.vue?vue&type=template&id=d5be9da4&scoped=true&"
import script from "./Passport.vue?vue&type=script&lang=js&"
export * from "./Passport.vue?vue&type=script&lang=js&"
import style0 from "./Passport.vue?vue&type=style&index=0&id=d5be9da4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5be9da4",
  null
  
)

export default component.exports